"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VERSION = void 0;
function VERSION() {
    return _version.split(".");
}
exports.VERSION = VERSION;
let _version = "2.0.0";
_version = '2.2.0';
